import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import type {EmailCampaignSendingOptionsPanelProps} from '@Panels/email-campaign-sending-options-panel/email-campaign-sending-options-panel';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'email-campaign-sending-options-panel';

export interface EmailCampaignSendingOptionsModalProps extends EmailCampaignSendingOptionsPanelProps {}

export default function EmailCampaignSendingOptionModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.EMAIL_CAMPAIGN_SENDING_OPTIONS_MODAL];
  });

  const height = 'fit-content';
  const width = '100%';
  const maxWidth = '500px';
  const maxHeight = 'fit-content';

  return (
    <Modal modalId={MODALS_IDS.EMAIL_CAMPAIGN_SENDING_OPTIONS_MODAL} modalMaxHeight={maxHeight} modalHeight={height} modalMaxWidth={maxWidth} panelId={PANEL_ID} modalWidth={width}>
      <LazyPanel
        panelDirectoryName="email-campaign-sending-options-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openEmailCampaignSendingOptionsModal = (props: EmailCampaignSendingOptionsModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.EMAIL_CAMPAIGN_SENDING_OPTIONS_MODAL,
      panelProps: props,
    })
  );
};
